import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { CustomerProposalWrapper } from '../modules/ComponentsLibrary/ServiceCall/components/CustomerProposalWrapper';

export const Route = createFileRoute('/customer-proposal-preview/$quoteDocumentId')({
  component: RouteComponent,
  params: z.object({
    quoteDocumentId: z.coerce.number().positive(),
  }),
  head: () => ({
    meta: [
      {
        title: 'Customer Proposal Preview (Internal)',
      },
    ],
  }),
});

function RouteComponent() {
  const { quoteDocumentId } = Route.useParams();

  return (
    <CustomerProposalWrapper
      quoteDocumentId={quoteDocumentId}
      reload={() => {
        window.location.reload();
      }}
    />
  );
}
